import CreateItemPage from '../items/CreateItemPage';

const ListLuxuryPiecePage = () => <CreateItemPage luxuryPieceMode />;

export default ListLuxuryPiecePage;
